export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20night%20cityscape%20behind%20glass%2C%20warm%20amber%20and%20deep%20crimson%20bokeh%20lights%20reflecting%20on%20a%20large%20magnifying%20glass%20resting%20over%20vintage%20textured%20newspaper%20pages%2C%20moody%20chiaroscuro%20lighting%2C%20rich%20orange%20and%20red%20palette%2C%20abstract%20shapes%20instead%20of%20readable%20text%2C%20film%20grain%2C%20high%20contrast%2C%20no%20faces&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="吃瓜热点-深夜编辑部场景中的热点追踪氛围图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1320px] flex-col items-center px-4 md:px-6 pb-16 pt-40 md:pt-48 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs md:text-sm text-background-50 backdrop-blur-sm border border-white/20 whitespace-nowrap">
          <i className="ri-flashlight-line text-accent-300"></i>
          每天带你从一条热搜挖出一整张瓜田
        </span>

        <h1 className="mt-6 max-w-5xl font-heading text-3xl md:text-6xl font-black leading-tight text-background-50">
          同一个瓜，别人只看热闹
          <br />
          <span className="text-accent-300">我们帮你吃透吃全</span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-background-50/85">
          <span className="font-semibold text-accent-200">吃瓜热点</span>
          以<strong className="font-semibold text-background-50">关联事件、同类型瓜、历史对比、人物关系、幕后关联</strong>
          五个角度重新组织每一条热点，再用延伸阅读补齐背景，让你发现更多隐藏线索与意外惊喜。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-400"
          >
            <i className="ri-fire-line"></i>
            看看今日热榜
          </a>
          <a
            href="#topics"
            className="inline-flex items-center gap-2 rounded-md bg-white/10 px-6 py-3 text-sm md:text-base font-semibold text-background-50 whitespace-nowrap backdrop-blur-sm border border-white/25 transition-colors hover:bg-white/20"
          >
            <i className="ri-git-branch-line"></i>
            从关联事件切入
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-5">
          {[
            { t: '986万+', d: '今日讨论热度' },
            { t: '3000+', d: '事件持续跟进' },
            { t: '7×24', d: '热点实时追踪' },
            { t: '5维', d: '吃瓜切入角度' },
            { t: '100%', d: '来龙去脉还原' },
          ].map((s) => (
            <div key={s.d} className="rounded-lg border border-white/15 bg-white/5 px-3 py-4 backdrop-blur-sm">
              <p className="font-heading text-xl md:text-2xl font-bold text-accent-300">{s.t}</p>
              <p className="mt-1 text-[11px] md:text-xs text-background-50/75">{s.d}</p>
            </div>
          ))}
        </div>

        <a href="#hot" aria-label="下滑查看今日热榜" className="mt-10 text-background-50/70 transition-colors hover:text-accent-300">
          <i className="ri-arrow-down-double-line text-2xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}